import { render } from "./ReconciledButton.vue?vue&type=template&id=778187be"
import script from "./ReconciledButton.vue?vue&type=script&lang=js"
export * from "./ReconciledButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__